<template>
  <b-modal 
    id="modal-netlifyidentityuser"
    ref="modal" 
    centered 
    okTitle='Opslaan'
    cancelTitle='Annuleren'
    @ok="onOk"
    @show="onShow"
    :title="title">
    <template slot="default">
      <Feedback :feedback="feedback" />
      <Form 
        ref="form" 
        v-show="showForm"
        autocomplete="off"
        @error="handleError"
        @submit="handleSubmit">

        <FormField 
          v-for="(name, index) in Object.keys(fields)"
          :key="index"
          v-model="fields[name].value"
          v-bind="fields[name]" />

      </Form>
    </template>
  </b-modal>
</template>

<script>

import Feedback from 'atom/Feedback'
import Form from 'molecule/form/Form'
import FormField from 'molecule/form/FormField'

import { NewUserFields, EditUserFields } from '@/formfields/adminUserModal'

import fields from 'mixin/fields'
import timeout from 'mixin/timeout'

import { getUserById, updateUserById, createUser } from 'service/netlifyIdentity'

export default {
  name: 'NetlifyIdentityUserModal',
  components: {
    FormField, Form, Feedback
  },
  mixins: [ fields, timeout ],
  props: {
    userId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showForm: true,
      isDisabled: false,
      feedback: {},
      title: '',
      user: null,
      fields: {}
    }
  },
  computed: {
    editingUser() {
      return !! this.userId
    }
  },
  methods: {
    onShow() {
      this.showForm = false
      this.isDisabled = false
      this.resetFeedback()

      this.configureFields({
        userId: this.userId
      })
    },
    resetFeedback() {
      this.feedback = { show: false, dismissible: true }
    },
    async configureFields({ userId }) {

      if (this.editingUser) {
        this.fields = EditUserFields
      } else {
        this.fields = NewUserFields
      }

      // Reset fields on user info change
      this.clearAllFieldValues()
      if (this.editingUser) {
        this.title = 'Bezig met ophalen van informatie'

        this.user = await getUserById({
          id: userId
        })
        .then(response => response.data)
        .catch(() => null)

        if (this.user !== null) {
          
          this.setFieldValues([
            { name: 'role', value: (this.user.app_metadata.roles ? this.user.app_metadata.roles[0] : this.fields.role.options[0].value ) },
            { name: 'organisation', value: this.user.app_metadata.org || this.fields.organisation.options[0].value },
            { name: 'active', value: this.user.app_metadata.active || this.fields.active.options[0].value},
            { name: 'name', value: this.user.user_metadata.full_name }
          ])
          this.title = `Gebruiker: ${this.user.user_metadata.full_name}`

          // If the active user is the same as the user being edited
          // this.fields.role.permaDisabled = (this.userId === getUser().id)

          this.showForm = true
          let vm = this
          this.$nextTick(() => {
            vm.$refs.form.resetValidation()
          })

        } else {
          
          this.title = 'Foutmelding'
          this.feedback = {
            variant: 'danger', 
            message: 'De gebruikersinformatie kon niet geladen worden.',
            dismissible: false
          }
        }
        
      } else {
        this.user = null
        this.title = 'Gebruiker toevoegen'
        this.setFieldValues([
          { name: 'role', value: this.fields.role.options[0].value },
          { name: 'organisation', value: this.fields.organisation.options[0].value }
        ])
        this.showForm = true
        let vm = this
        this.$nextTick(() => {
          vm.$refs.form.resetValidation()
        })
      }
    },
    onOk(e) {
      e.preventDefault()
      if ( ! this.isDisabled) {
        this.$refs.form.submit()
      }
    },
    async handleSubmit() {
      this.disableAllFields()
      this.isDisabled = true;
      this.feedback = {
        variant: 'info', 
        message: 'Bezig met opslaan...'
      }
      
      try {
        if (this.user) {
          await updateUserById({
            id: this.user.id,
            attributes: {
              role: this.fieldValue('role'),
              org: this.fieldValue('organisation'),
              active: this.fieldValue('active'),
              full_name: this.fieldValue('name')
            }
          })
        } else {
          let response = await createUser({
            email: this.fieldValue('email'),
            password: this.fieldValue('password'),
            attributes: {
              role: this.fieldValue('role'),
              org: this.fieldValue('organisation'),
              full_name: this.fieldValue('name')
            }
          })

          // Yup... this ugly solutions is here because Netlify does not appear to accept all input upon creation...
          if (response) {
            await updateUserById({
              id: response.id,
              attributes: {
                role: this.fieldValue('role'),
                org: this.fieldValue('organisation'),
                active: "yes"
              }
            })
          }
        }
        
        this.feedback = {
          variant: 'success',
          message: 'De wijzigingen zijn opgeslagen'
        }
        this.showForm = false

        this.setTimeout(() => {
          this.user = null
          this.$refs.modal.hide()
          this.$emit("refresh")

          this.setTimeout(() => {
            this.isDisabled = false
            this.enableAllFields()
            this.clearAllFieldValues()
          }, 400)
        }, 500)
        
      } catch (err) {
        this.feedback = {
          variant: 'danger', 
          message: 'Wijzigingen zijn niet opgeslagen'
        }
        this.isDisabled = false
        this.enableAllFields()
      }
      
    },
    handleError() {
      this.feedback = {
        variant: 'danger', 
        message: 'Controleer de validatie berichten a.u.b.'
      }
    }
  }
}
</script>
